import { type OperationContext, type OperationResult, useMutation } from "urql"

import type {
  CompetitorProductMutationCreateArgs,
  CompetitorProductMutationDeleteArgs,
  CompetitorProductMutationUpdateArgs,
  Mutation,
} from "@/graphql/codegen/graphql"
import {
  CreateCompetitorProductDocument,
  DeleteCompetitorProductDocument,
  UpdateCompetitorProductDocument,
} from "@/graphql/codegen/graphql"

interface UseCompetitorProductReturn {
  createCompetitorProduct: (
    variables: CompetitorProductMutationCreateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "competitorProduct">, CompetitorProductMutationCreateArgs>>
  updateCompetitorProduct: (
    variables: CompetitorProductMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "competitorProduct">, CompetitorProductMutationUpdateArgs>>
  deleteCompetitorProduct: (
    variables: CompetitorProductMutationDeleteArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "competitorProduct">, CompetitorProductMutationDeleteArgs>>
}

export const useCompetitorProduct = (): UseCompetitorProductReturn => {
  const [, createCompetitorProduct] = useMutation<
    Pick<Mutation, "competitorProduct">,
    CompetitorProductMutationCreateArgs
  >(CreateCompetitorProductDocument)

  const [, updateCompetitorProduct] = useMutation<
    Pick<Mutation, "competitorProduct">,
    CompetitorProductMutationUpdateArgs
  >(UpdateCompetitorProductDocument)

  const [, deleteCompetitorProduct] = useMutation<
    Pick<Mutation, "competitorProduct">,
    CompetitorProductMutationDeleteArgs
  >(DeleteCompetitorProductDocument)

  return {
    createCompetitorProduct,
    updateCompetitorProduct,
    deleteCompetitorProduct,
  }
}
